<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page>
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="userName"
                    label="用户名"
                >
                    <el-input
                        v-model="queryFormModel.userName"
                        placeholder="请输入用户名"
                    />
                </el-form-item>
                <el-form-item
                    prop="mobile"
                    label="电话"
                >
                    <el-input
                        v-model="queryFormModel.mobile"
                        placeholder="请输入电话"
                    />
                </el-form-item>
                <el-form-item
                    prop="buyerLevelId"
                    label="会员等级"
                >
                    <RemoteSelect
                        clearable
                        remote="/mb/buyerLevel/select"
                        placeholder="请输入"
                        :props="{id:'id',name:'levelName'}"
                        v-model="queryFormModel.buyerLevelId"
                    />
                </el-form-item>
                <el-form-item
                    prop="distributorLevelId"
                    label="分销商等级"
                >
                    <RemoteSelect
                        clearable
                        remote="/mb/distributorLevel/select"
                        placeholder="请输入"
                        :props="{id:'id',name:'levelName'}"
                        v-model="queryFormModel.distributorLevelId"
                    />
                </el-form-item>
                <el-form-item
                    prop="cardName"
                    label="卡名称"
                >
                    <el-input
                        v-model="queryFormModel.cardName"
                        placeholder="请输入卡名称"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
            >
                <el-table-column
                    prop="userName"
                    label="用户名"
                    width="105"
                />
                <el-table-column
                    prop="mobile"
                    label="电话"
                    width="105"
                />
                <el-table-column
                    prop="buyerLevelName"
                    label="会员等级"
                    width="90"
                />
                <el-table-column
                    prop="distributorLevelName"
                    label="分销商等级"
                    width="90"
                />
                <el-table-column
                    prop="cardName"
                    label="卡名称"
                    min-width="100"
                />
                <el-table-column
                    label="有效期"
                    width="60"
                >
                    <template slot-scope="scope">
                        {{scope.row.validityValue}}{{scope.row.validityTypeName}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="cardSn"
                    label="卡号"
                    min-width="100"
                />
                <el-table-column
                    label="有效期开始"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.validBeginTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="有效期结束"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.validEndTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="60"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="$router.push( '/mb/benefitCard/buyerBenefitCard/detail/' + scope.row.id)"
                        >
                            详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'BuyerBenefitCard',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                userName: '',
                mobile: '',
                buyerLevelId: '',
                distributorLevelId: '',
                cardName: '',
            },
            // 表格数据
            tableData: [],
            // 表格当前选中行
            currentTableSelect: [],
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Mb.BuyerBenefitCard.data(queryData).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
    },
};
</script>

<style lang="scss">
</style>
